export const reasonOptions = [
    { label: 'Minimize my monthly payment', value: 'minimize_payment' },
    { label: 'Pay my loan off sooner', value: 'pay_off_sooner' },
    // { label: 'Reduce my rate over similar payoff time', value: 'reduce_rate_similar_payoff' },
];